import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';


import { AjaxService } from '../../../services/ajax.service';
import { DirectionService } from '../../../services/direction.service';
import { ViewScopeService } from '../../../services/view-scope.service';

import { WorkersBasicRecord, WorkersEmailDataRecord, WorkersPhoneDataRecord } from '../../../models/workers-general-record.model';
import { WORKER_REASSIGN, PHONE_TYP_DEFINERS, PHONE_PEF_DEFINERS, WORKER_DATA, WORKER_ALL_MAILS, WORKER_ALL_PHONES, WORKER_PHONE_INS, WORKER_PHONE_UPD, WORKER_PHONE_SET, WORKER_PHONE_ACT, WORKER_PHONE_DEL, WORKER_EMAIL_INS, WORKER_EMAIL_UPD, WORKER_EMAIL_SET, WORKER_EMAIL_ACT, WORKER_EMAIL_DEL } from '../../../services/account-api.constants';


@Injectable(
	{
		providedIn: 'root'
	})


export class WorkersInfoService {
	public workersData?: WorkersBasicRecord;

	constructor(private ajaxService: AjaxService, private directionService: DirectionService, private viewScopeService: ViewScopeService) {

	}

	public loadAllMyWorkers() {
		const lang = this.directionService.isRtl(); // True for Rtl.

		const companyId = this.viewScopeService.getSelectedCompanyId()!;
		const operatorId = this.viewScopeService.getCurrentOpertaingUserId();

		return this.callForWorkersData(companyId, operatorId).pipe(
			map((response: any) => {
				return (response || []).map((item: any) => (
				{
					UserRecID	: item.UserRecID,
					UserName	: item.UserName,
					FirstName	: lang ? item.FirstName_HE : item.FirstName,
					LastName	: lang ? item.LastName_HE : item.LastName,
					FirstNameHE	: item.FirstName_HE,
					LastNameHE	: item.LastName_HE,
					FirstNameEN	: item.FirstName,
					LastNameEN	: item.LastName,
					RoleRecID 	: item.RoleRecID,
					Role		: item.Role,
					RoleColor	: item.ColorNotification,
					Phones		: item.Phones,
					Emails		: item.Emails,
					Descr		: item.Descr,
					IsActive	: item.IsActive,
					IsLogIn		: item.IsLogIn,
				})) as WorkersBasicRecord[];
			})
		);

	}




	public loadWorkersEmails(workerUserID: number) {

		const operatorId = this.viewScopeService.getCurrentOpertaingUserId();

		return this.readWorkersEmailData(workerUserID, operatorId).pipe(
			map((response: any) => {
				return (response || []).map((item: any) => ({
					EmailUserRecID : item.EmailUserRecID,
					EmailRecID: item.EmailRecID,
					Email: item.Email,
					Descr: item.Descr,
					IsActive: item.IsActive,
					DateEntered: item.DateEntered,
					IsMain: item.IsMain
				})) as WorkersEmailDataRecord[];
			})
		);
	}


	public loadWorkersPhones(workerUserID: number) {

		const operatorId = this.viewScopeService.getCurrentOpertaingUserId();

		return this.readWorkersPhoneData(workerUserID, operatorId).pipe(
			map((response: any) => {
				return (response || []).map((item: any) => ({
					PhoneUserRecID: item.PhoneUserRecID,
					PhoneNumber: item.PhoneNumber,
					PhoneRecID: item.PhoneRecID,
					PhonePrefRecID: item.PhonePrefRecID,
					PhoneTypeRecID: item.PhoneTypeRecID,
					Pref: item.Pref,
					Phone: item.Phone,
					Descr: item.Descr,
					IsActive: item.IsActive,
					PhoneType: item.PhoneType,
					DateEntered: item.DateEntered,
					IsMain: item.IsMain
				})) as WorkersPhoneDataRecord[];
			})
		);
	}




	private callForWorkersData(compID: number, userOpID: number): Observable<WorkersBasicRecord[]> {
		return this.ajaxService.getData(this.ajaxService.getBaseOfApi() + '/' + WORKER_DATA + compID + '/' + userOpID) as Observable<WorkersBasicRecord[]>;
	}

	private readWorkersEmailData(workerUserID: number, userOpID: number): Observable<WorkersEmailDataRecord[]> {
		return this.ajaxService.getData(this.ajaxService.getBaseOfApi() + '/' + WORKER_ALL_MAILS + workerUserID + '/' + userOpID) as Observable<WorkersEmailDataRecord[]>;
	}

	private readWorkersPhoneData(workerUserID: number, userOpID: number): Observable<WorkersPhoneDataRecord[]> {
		return this.ajaxService.getData(this.ajaxService.getBaseOfApi() + '/' + WORKER_ALL_PHONES + workerUserID + '/' + userOpID) as Observable<WorkersPhoneDataRecord[]>;
	}

	public getCustomersOfWorkers(selectedWorkerID: number) {
		return this.viewScopeService.getCustomers(selectedWorkerID);
	}

	public getPhonesTypes() {
		return this.ajaxService.getData(this.ajaxService.getBaseOfApi() + PHONE_TYP_DEFINERS + this.viewScopeService.getCurrentOpertaingUserId());
	}

	public getPhonesPrefs() {
		return this.ajaxService.getData(this.ajaxService.getBaseOfApi() + PHONE_PEF_DEFINERS + this.viewScopeService.getCurrentOpertaingUserId());
	}


	public setContactAsMain(actionCode: number, rowRecID: number, isMain: 0 | 1) 
	{
		const apiUrl = this.ajaxService.getBaseOfApi() + (actionCode === 0 ? WORKER_PHONE_SET : WORKER_EMAIL_SET);
		const payload = this.createPayloadForMainContact(rowRecID, isMain);
		return this.ajaxService.updateObjectData(apiUrl, payload);
	}


	public setContactActivity(actionCode: number, rowRecID: number, isActive: 0 | 1) 
	{
		const apiUrl = this.ajaxService.getBaseOfApi() + (actionCode === 0 ? WORKER_PHONE_ACT : WORKER_EMAIL_ACT);
		const payload = this.createPayloadForActivityContact(rowRecID, isActive);
		return this.ajaxService.updateObjectData(apiUrl, payload);
	}

	public deleteContact(actionCode: number, rowRecID: number) 
	{
		const apiUrl = this.ajaxService.getBaseOfApi() + (actionCode === 0 ? WORKER_PHONE_DEL : WORKER_EMAIL_DEL);
		const payload = this.createPayloadForDeletingContact(rowRecID);
		return this.ajaxService.updateObjectData(apiUrl, payload);
	}

	
	public saveContact(operationId: number, actionCode: number, payload: any) 
	{
		const apiUrl = this.ajaxService.getBaseOfApi() + (operationId === 0 ? (actionCode === 0 ? WORKER_PHONE_INS : WORKER_EMAIL_INS) : (actionCode === 0 ? WORKER_PHONE_UPD : WORKER_EMAIL_UPD));

		const request$ = operationId === 0 ? this.ajaxService.addObjectData(apiUrl, payload) : this.ajaxService.updateObjectData(apiUrl, payload);

		request$.subscribe({
			next: (response) => {
				if (Array.isArray(response) && response.length > 0 && response[0].RecID) 
				{
					console.log(`Phone/email saved, RecID ${response[0].RecID}.`);
				}
			},
			error: (error) => {
				console.error('Error in saveContact:', error);
			}
		});
	}


	private createPayloadForMainContact(recId: number, isMain: 0 | 1): { RecID: number, IsMain: 0 | 1, UserRecID: number } 
	{
		const payload = 
		{
			RecID: recId,
			IsMain: isMain,
			UserRecID: this.viewScopeService.getCurrentOpertaingUserId()
		};
		// For debugging/logging: justified JSON
		console.log('Set contact main:', JSON.stringify(payload));
		return payload;
	}

	private createPayloadForActivityContact(recId: number, isActive: 0 | 1): { RecID: number, IsActive: 0 | 1, UserRecID: number }
	{
		const payload = 
		{
			RecID: recId,
			IsActive: isActive,
			UserRecID: this.viewScopeService.getCurrentOpertaingUserId()
		};
		// For debugging/logging: justified JSON
		console.log('Set contact activity:', JSON.stringify(payload));
		return payload;
	}

	private createPayloadForDeletingContact(recId: number): { RecID: number, UserRecID: number}
	{
		const payload = 
		{
			RecID: recId,
			UserRecID: this.viewScopeService.getCurrentOpertaingUserId()
		};
		// For debugging/logging: justified JSON
		console.log('Delete contact:', JSON.stringify(payload));
		return payload;
	}

	public assignCustomerToWorker(userCustomerRecID: number, userRecID: number) {
		const apiUrl = this.ajaxService.getBaseOfApi() + WORKER_REASSIGN;
		return this.ajaxService.updateObjectData(apiUrl, this.createPaylodToReassignCustomer(userCustomerRecID, userRecID));
	}


	private createPaylodToReassignCustomer(userCustomerRecID: number, userRecID: number)
	{
		const payload = 
		{
			UserCustomerRecID: userCustomerRecID,
			UserRecID: userRecID,
			Descr : "Modified by user number: " + this.viewScopeService.getCurrentOpertaingUserId(),
			IsActive: 1,
			opUserRecID: this.viewScopeService.getCurrentOpertaingUserId()
		};
		console.log('????? ', JSON.stringify(payload));
		
		return JSON.stringify(payload);
	}
}
